module.exports = __webpack_public_path__ + "img/cl.5580e278.svg";